import { render, staticRenderFns } from "./SupportPage.vue?vue&type=template&id=7ca2622a&scoped=true&"
import script from "./SupportPage.vue?vue&type=script&lang=js&"
export * from "./SupportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca2622a",
  null
  
)

export default component.exports